import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{staticClass:"fill-height",attrs:{"fluid":"","id":"recover-password"}},[_c(VRow,[_c('login-selo',{scopedSlots:_vm._u([{key:"formulario",fn:function(){return [_c('RecoverPasswordForm')]},proxy:true}])})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }